import sound_on from "../../_assets/images/sound_on.png";
import { Link, useLocation } from "react-router-dom";
import { MainContainer, Container } from "../ComponentCss";
import WarComponent from "./WarComponent";
import MarriageComponent from "./MarriageComponent";

const ASMRMainComponent = ({ spyEle, setSpyEle, setBgIsBlack, setSupportVisible, warEleRef, marrEleRef }) => {
    const location = useLocation();
    
    return (
        <MainContainer>
            <Container>
                <nav>
                    <Link to="/" className="active-tab">ASMR 체험하기</Link>
                    <Link to="?step=qna">반전문답 확인하기</Link>
                </nav>
                <div className="main-inner">
                    <div className="main-comm">
                        <h1>이곳은 ASMR 체험존입니다.</h1>
                        <p>소리가 잘 들리는 환경에서<br className="mo" /> 감상해 주세요.</p>
                        <img src={ sound_on } alt='sound_on_img' />
                    </div>
                    <div className="btn-cont">
                        <Link to="?step=war" className={ spyEle === 'war' ? 'active' : ''}>
                            <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/war_btn.c4d36c18acbd6c5429ef.jpg" } alt="전쟁 ASMR 체험존" className="pc" />
                            전쟁 ASMR 체험존
                        </Link>
                        <Link to="?step=earlymarriage" className={ spyEle === 'marriage' ? 'active' : ''}>
                            <img src={ "https://cdn.unicef.or.kr/images/22unicef-asmr/static//media/marriage_btn.c57602d745ac81f734b2.jpg" } alt="조혼 ASMR 체험존" className="pc" />
                            조혼 ASMR 체험존
                        </Link>
                    </div>
                    <p className="pc">위 버튼을 클릭해 <b>원하는 ASMR 체험존</b>으로 입장해주세요.</p>
                </div>
            </Container>
      {
          location.search.indexOf("war") > -1 ? <WarComponent playState={spyEle} setSpyEle={ setSpyEle } setBgIsBlack={setBgIsBlack} setSupportVisible={setSupportVisible} warEleRef={ warEleRef }  /> : 
          location.search.indexOf("marriage") > -1 ? <MarriageComponent playState={spyEle} setSpyEle={ setSpyEle } setBgIsBlack={setBgIsBlack} setSupportVisible={setSupportVisible} marrEleRef={ marrEleRef } /> : <></>
      }
        </MainContainer>
    );
}

export default ASMRMainComponent;
